import { createAction, props } from '@ngrx/store';
import {
  ConsumerIdentityParam,
  GetBrandBriefResponse,
  GetDeviceParams,
  GetEndUserLinesParams,
  GetEndUserLinesResponse,
  GetSimParams,
  GetUserPlansV2Params,
  GetUserPlansV2Response,
  Line,
  SimsV2Sim,
  UpdateConsumerIdentityResponse,
  OxErrorResponse,
  DeviceInfo,
} from 'src/app/core';
import { UpdateEndUserParams } from 'src/app/core/proto/whitepages/consumers';
import { EndUser } from 'src/app/core/proto/whitepages/consumers/interfaces';

export enum EndUsersActionTypes {
  EndUsersEndUserGet = '[EndUsers] EndUser Get',
  EndUsersEndUserGetSuccess = '[EndUsers] EndUser Get Success',
  EndUsersEndUserGetFailure = '[EndUsers] EndUser Get Failure',
  EndUsersEndUserUpdate = '[EndUsers] EndUser Update',
  EndUsersEndUserUpdateSuccess = '[EndUsers] EndUser Update Success',
  EndUsersEndUserUpdateFailure = '[EndUsers] EndUser Update Failure',
  EndUsersEndUserDestroy = '[EndUsers] EndUser Destroy',
  EndUsersLinesGet = '[EndUsers] EndUserLine Get',
  EndUsersLinesGetSuccess = '[EndUsers] EndUserLine Get Success',
  EndUsersLinesGetFailure = '[EndUsers] EndUserLine Get Failure',
  EndUsersLineSelect = '[EndUsers] EndUserLine Select Line',
  EndUsersLineSelectDestroy = '[EndUsers] EndUserLine Select Line Destroy',
  EndUsersSimGet = '[EndUsers] Sim Get',
  EndUsersSimGetSuccess = '[EndUsers] Sim Get Success',
  EndUsersSimGetFailure = '[EndUsers] Sim Get Failure',
  EndUsersDevicesGet = '[EndUsers] Devices Get',
  EndUsersDevicesGetSuccess = '[EndUsers] Devices Get Success',
  EndUsersDevicesGetFailure = '[EndUsers] Devices Get Failure',
  EndUsersBrandGet = '[EndUsers] Brand Get',
  EndUsersBrandGetSuccess = '[EndUsers] Brand Get Success',
  EndUsersBrandGetFailure = '[EndUsers] Brand Get Failure',
  EndUsersUserPlansGet = '[EndUsers] UserPlans Get',
  EndUsersUserPlansGetSuccess = '[EndUsers] UserPlans Get Success',
  EndUsersUserPlansGetFailure = '[EndUsers] UserPlans Get Failure',
}

// UserPlans
export const actionEndUsersUserPlansGet = createAction(
  EndUsersActionTypes.EndUsersUserPlansGet,
  props<{ params: GetUserPlansV2Params }>()
);
export const actionEndUsersUserPlansGetSuccess = createAction(
  EndUsersActionTypes.EndUsersUserPlansGetSuccess,
  props<{ payload?: GetUserPlansV2Response }>()
);
export const actionEndUsersUserPlansGetFailure = createAction(
  EndUsersActionTypes.EndUsersUserPlansGetFailure
);

// Brand
export const actionEndUserBrandGet = createAction(
  EndUsersActionTypes.EndUsersBrandGet,
  props<{ brandUuid: string }>()
);
export const actionEndUserBrandGetSuccess = createAction(
  EndUsersActionTypes.EndUsersBrandGetSuccess,
  props<{ payload?: GetBrandBriefResponse }>()
);
export const actionEndUserBrandGetFailure = createAction(
  EndUsersActionTypes.EndUsersBrandGetFailure
);

// EndUserDevice
export const actionEndUserDevicesGet = createAction(
  EndUsersActionTypes.EndUsersDevicesGet,
  props<{ params: GetDeviceParams }>()
);
export const actionEndUserDevicesGetSuccess = createAction(
  EndUsersActionTypes.EndUsersDevicesGetSuccess,
  props<{ payload?: DeviceInfo }>()
);
export const actionEndUserDevicesGetFailure = createAction(
  EndUsersActionTypes.EndUsersDevicesGetFailure
);

// EndUserSim
export const actionEndUserSimGet = createAction(
  EndUsersActionTypes.EndUsersSimGet,
  props<{ params: GetSimParams }>()
);
export const actionEndUserSimGetSuccess = createAction(
  EndUsersActionTypes.EndUsersSimGetSuccess,
  props<{ payload?: SimsV2Sim }>()
);
export const actionEndUserSimGetFailure = createAction(
  EndUsersActionTypes.EndUsersSimGetFailure
);

// EndUserLine
export const actionEndUserLinesGet = createAction(
  EndUsersActionTypes.EndUsersLinesGet,
  props<{ params: GetEndUserLinesParams }>()
);
export const actionEndUserLinesGetSuccess = createAction(
  EndUsersActionTypes.EndUsersLinesGetSuccess,
  props<{ payload?: GetEndUserLinesResponse }>()
);
export const actionEndUserLinesGetFailure = createAction(
  EndUsersActionTypes.EndUsersLinesGetFailure
);

// EndUserLine Select line
export const actionEndUsersLineSelect = createAction(
  EndUsersActionTypes.EndUsersLineSelect,
  props<{ selectedLine: Line }>()
);
export const actionEndUsersLineSelectDestroy = createAction(
  EndUsersActionTypes.EndUsersLineSelectDestroy
);

// Get EndUser
export const actionEndUserGet = createAction(
  EndUsersActionTypes.EndUsersEndUserGet,
  props<{
    consumerIdentityParam: ConsumerIdentityParam;
    value: string;
    brandId?: string;
  }>()
);
export const actionEndUserGetSuccess = createAction(
  EndUsersActionTypes.EndUsersEndUserGetSuccess,
  props<{
    payload?: EndUser;
    searchedEndUserParams: {
      param: string;
      value: string;
    };
  }>()
);
export const actionEndUserGetFailure = createAction(
  EndUsersActionTypes.EndUsersEndUserGetFailure
);

// Update EndUser
export const actionEndUserUpdate = createAction(
  EndUsersActionTypes.EndUsersEndUserUpdate,
  props<{
    endUserId: string;
    updateEndUserParams: UpdateEndUserParams;
  }>()
);
export const actionEndUserUpdateSuccess = createAction(
  EndUsersActionTypes.EndUsersEndUserUpdateSuccess,
  props<{ payload?: UpdateConsumerIdentityResponse }>()
);
export const actionEndUserUpdateFailure = createAction(
  EndUsersActionTypes.EndUsersEndUserUpdateFailure,
  props<OxErrorResponse>()
);

// Destroy EndUser
export const actionEndUserDestroy = createAction(
  EndUsersActionTypes.EndUsersEndUserDestroy
);
